/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect, Fragment } from 'react';
import { toastr } from 'react-redux-toastr';

import '../StyleModal.css';
import botAvatarImg from '../../../../assets/images/bot_avatar.png';
import Avatar from 'react-avatar';
import { readableBytes } from '../../../NewBot/Components/utils';
import NewEditImgModal from './NewEditImgModal';

const uploadLabelStyle = { fontWeight: 'normal' };


const UploadFotoProfile = (props) => {
  const { currentFile, name } = props;

  const [showCropModal, setShowCropModal] = useState(false);
  const [canRenderCropper, setCanRenderCropper] = useState(false);
/* funcao capta a imagem escolhida pelo input */
  const onChangeBotAvatarInput = (event) => {
    event.preventDefault();
    const blob = URL.createObjectURL(event.target.files[0]);
    const file = new File([blob], `test.png`, {
      type: 'image/*',
      lastModified: Date.now(),
    });
    const { value, base } = readableBytes(file.size);

    if (base !== 'B' && base !== 'KB') {
      if (value > 5) {
        toastr.error(
          'Ops',
          'Por favor, a imagem deve ter tamanho máximo de 5 MB.'
        );
        return;
      }
    }

    const img = document.createElement('img');
    img.src = blob;
    img.style = { display: 'none' };
    img.onload = function () {
      const { width, height } = img;
      if (width !== 300 || height !== 300) {
        toastr.error('Ops', 'Por favor, a imagem deve ter 300x300.');
      } else {
        const { setCurrentFile } = props;
        setShowCropModal(true);
        setCanRenderCropper(true)
        setCurrentFile(this.file);
      }
    }.bind({ file: event.target.files[0] });
    event.target.value = null;
  };
/* funcao remove imagem usuario */
  const onClickRemoveBotAvatar = (event) => {
    event.preventDefault();
    const { setCurrentFile } = props;
    setCurrentFile(null);
  };

  const renderBotAvatar = () => {
    const currentFileValue =
      currentFile && typeof currentFile === 'object'
        ? URL.createObjectURL(currentFile)
        : currentFile;
    return currentFile && currentFile !== '' ? currentFileValue : botAvatarImg;
  };
/* funcao exibir span para clicar e remover a imagem usuario */
  const renderRemoveAvatarLabel = () => {
    if (!currentFile) {
      return false;
    }

    return <span onClick={onClickRemoveBotAvatar}>remover foto</span>;
  };
/* funcao que retorna o modal do cropper da imagem */
  const renderEditAvatarModal = () => {
    if (!showCropModal) {
      return false;
    }
    const { setCurrentFile } = props;

    return (
      <NewEditImgModal
        avatar={renderBotAvatar()}
        setCurrentFile={setCurrentFile}
        canRenderCropper={canRenderCropper}
        croppedImage={currentFile}
        setShowCropModal={setShowCropModal}
      />
    );
  };

  return (
    <Fragment>
      <div className="container-imagem-Profile">
        
        <div className="new-bot-create-element-row avatar">
          <div style={{ marginLeft: 150, marginRight: 15}}>
          {currentFile ?
            <img className="img-profile-upload"
              src={currentFile}
              alt="Avatar" 
            /> 
          : 
          <div className="img-profile-upload">
          <Avatar 
          name={name} 
          size="100" 
          round={true}
          color={Avatar.getRandomColor('sitebase', ['red', 'green', 'blue', 'gray'])} />
          </div>}
          </div>
          <div className="new-bot-create-element-column">
            <div className="new-bot-element-column-row">
              <div className="new-bot-create-upload-input">
                <label htmlFor="avatar-bot" style={uploadLabelStyle}>
                  Upload de arquivo
                </label>
                <input
                  id="avatar-bot"
                  type="file"
                  accept=".png,.jpg,.jpeg"
                  onChange={onChangeBotAvatarInput}
                />
              </div>
              {renderRemoveAvatarLabel()}
            </div>
            <span >
              imagem deve estar em formato .JPG, .JPEG ou .PNG ter no mínimo
              300x300 pixels e no máximo 5mb
            </span>
          </div>
        </div>
      </div>
      <div className="new-bot-modal">{renderEditAvatarModal()}</div>
    </Fragment>
  );
};

export default UploadFotoProfile;